import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { User } from 'lucide-react';
import { PlayerSelectorModal } from './PlayerSelectorModal';

interface PlayerSelection {
  playerName: string;
  playerId?: string; // Player externalId (for grading_data)
  playerPosition?: string; // Player position (for grading_data)
  teamId?: string; // Team externalId (for grading_data)
  jerseyNo: number;
  teamName: string;
  teamAbbr: string;
  jerseyUrl: string;
  teamLogoUrl: string;
  sport: string;
}

interface PlayerPickerButtonProps {
  onSelect: (selection: PlayerSelection) => void;
  selectedTeams: string[];
  fieldLabel?: string;
  disabled?: boolean;
  /** When set, auto-selects this league and disables the league selector in the modal */
  restrictedLeagueId?: string;
  /** Contest League IP flag — drives licensed vs generic image auto-fill */
  leagueIp?: boolean;
}

export function PlayerPickerButton({
  onSelect,
  selectedTeams,
  fieldLabel,
  disabled = false,
  restrictedLeagueId,
  leagueIp = false,
}: PlayerPickerButtonProps) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setModalOpen(true)}
        disabled={disabled}
        className="shrink-0"
        title={disabled && selectedTeams.length === 0 ? 'Select teams first' : 'Select player'}
      >
        <User className="h-4 w-4" />
      </Button>
      <PlayerSelectorModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        onSelect={onSelect}
        selectedTeams={selectedTeams}
        fieldLabel={fieldLabel}
        restrictedLeagueId={restrictedLeagueId}
        leagueIp={leagueIp}
      />
    </>
  );
}
